import React from 'react'
import { Button, Text, VStack, Box, Select } from '@chakra-ui/react'
import {
  DialogContainer,
  DialogActions,
  DialogHeader,
  DialogBody
} from '@handlers/sessions/components/dialog'
import { Mic } from '@components/icons'
import { useAudioCapture, useExperienceManager } from '@hooks'
import { useStoreState } from 'easy-peasy'
import { useContentShareState } from 'amazon-chime-sdk-component-library-react'
import { isMobile } from 'react-device-detect'

export const SettingsDialog = ({ isOpen, onClose, onShareAudio }: any) => {
  const {
    audioInputs,
    setSelectedAudioInput,
    selectedAudioInput
  } = useAudioCapture()

  const { isSafari, isExtension } = useExperienceManager()
  const { audioLevel } = useStoreState(state => state.volume)

  const { isLocalUserSharing } = useContentShareState()

  const handleShareAudio = () => {
    onShareAudio()
    onClose()
  }

  return (
    <DialogContainer
      onClose={onClose}
      isOpen={isOpen}
      isExtension={isExtension}
    >
      <DialogActions onClose={onClose} />
      <DialogBody>
        <VStack spacing={6}>
          <Box>
            <Mic
              filterId={'consentModalPreview'}
              dy={1 - audioLevel}
              width="80px"
              height="80px"
            />
          </Box>
          <Box textAlign="center">
            <DialogHeader text="Select a microphone" />
            <Text>
              The icon above should light up green when you speak out loud.
            </Text>
          </Box>
          <Box w="100%">
            <Select
              onChange={e => setSelectedAudioInput(e.target.value)}
              value={selectedAudioInput}
              border="1px solid"
              height="40px"
              borderColor="pale_gray"
              _focus={{ outline: 'none' }}
            >
              {audioInputs.map(input => (
                <option key={input.deviceId} value={input.deviceId}>
                  {input.label}
                </option>
              ))}
            </Select>
          </Box>
          {!isLocalUserSharing && !isSafari && !isMobile && (
            <Box>
              <Text fontWeight="bold" paddingBottom="xsmall">
                Share audio from another browser tab
              </Text>
              {!isExtension && (
                <Text paddingBottom="xsmall">
                  This is especially helpful if you are using headphones for a
                  telehealth session and want the AI Notetaker to capture what
                  your client is saying.
                </Text>
              )}
              <Button
                variant="link"
                onClick={handleShareAudio}
                m={0}
                textDecoration="none"
                _hover={{ textDecoration: 'none' }}
                _focus={{ outline: 'none', textDecoration: 'none' }}
              >
                Share browser audio
              </Button>
            </Box>
          )}
        </VStack>
      </DialogBody>
    </DialogContainer>
  )
}
